import * as React from 'react'
import classNames from 'classnames'
import { AGREEMENT_TYPE, agreementType } from '../constants'
import Enterprise from './enterprise'
import OneOff from './one-off'
import Pass from './pass'
import { humanize } from 'helpers/strings'

const DownloadSliderAgreement = ({
  agreement = {},
  form,
  entity,
  multiple,
  price,
  isRepeated,
}) => {
  const Component =
    agreement.agreement_type === AGREEMENT_TYPE.PASS
      ? Pass
      : agreement.agreement_type === AGREEMENT_TYPE.ONE_OFF
      ? OneOff
      : Enterprise

  const isLimit = agreement?.can_download_content.why_not_reason === 'limit'
  const disabled =
    !agreement?.can_download_content.can ||
    agreement?.can_download_content.why_not_reason !== 'none'
  const isOneOff = agreement.agreement_type === 'one_off'

  return (
    <div className={classNames('side-buy-plan', { 'radio-button': multiple })}>
      <input
        checked={agreement.id === form.agreement_id}
        className="radio-button__input"
        disabled={disabled}
        id={agreement.id}
        name="agreement_id"
        type="radio"
        value={agreement.id}
      />
      <label
        className={classNames('side-popup__subtitle', {
          'radio-button__label': multiple,
          'side-popup__subtitle--reached': isLimit && !isOneOff,
        })}
        htmlFor={agreement.id}
      >
        {humanize(agreementType(agreement.agreement_type))}
      </label>

      <Component
        agreement={agreement}
        entity={entity}
        form={form}
        isRepeated={isRepeated}
        price={price}
      />
    </div>
  )
}

export default DownloadSliderAgreement
